// OrderDetailsModal/CloseButton.jsx

import React from "react";
import ActionButton from "./actionBtn";

export default function CloseButton({ onClose, isFullScreen }) {
  return (
    <ActionButton
      variant="outline-primary"
      onClick={onClose}
      isFullScreen={isFullScreen}
    >
      Хаах
    </ActionButton>
  );
}
